import {Field, useFormikContext} from 'formik'
import React, {Fragment, useEffect} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'

import SelectField from '../../../../components/SelectField'
import WebcamCapture from '../../../../components/Webcam'
import {StepHeader} from '../../styles'

import IdFrameBack from '../../../../assets/SVG/moldura-rg-verso.svg'
import RneFrameBack from '../../../../assets/SVG/rne-verso.svg'
import CnhFrameBack from '../../../../assets/SVG/cnh-verso.svg'

const frames = {
  IDENTITY_CARD_VERSE: IdFrameBack,
  DRIVER_LICENSE_VERSE: CnhFrameBack,
  RNE_VERSE: RneFrameBack,
}

const Step14 = () => {
  const {setFieldValue, setFieldTouched, values} = useFormikContext()
  const {documentType} = values
  useEffect(() => {
    setFieldValue('documentType', '')
    setFieldValue('image', '')
    setFieldTouched('documentType', false)
    setFieldTouched('image', false)
  }, [setFieldTouched, setFieldValue])
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 3 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Agora uma foto do verso do seu documento.
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              label="Tipo de documento"
              native
              name="documentType"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              <option value="DRIVER_LICENSE_VERSE">CNH - Verso</option>
              <option value="IDENTITY_CARD_VERSE">RG  - Verso</option>
              <option value="RNE_VERSE">Registro Nacional de Estrangeiro - Verso</option>
              <option value="EMANCIPATION_STATEMENT">Carta de Emancipação</option>
              <option value="PASSPORT">Passaporte</option>
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Field
              frame={frames[documentType] || IdFrameBack}
              name="image"
              facingMode="environment"
              component={WebcamCapture}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step14;
